import { render, staticRenderFns } from "./saticibilgi.vue?vue&type=template&id=6345f1a0&"
import script from "./saticibilgi.vue?vue&type=script&lang=js&"
export * from "./saticibilgi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports